import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, ArrowRight, CheckCircle2, ShieldCheck, Clock } from 'lucide-react';
import { Section, Accordion, CTAButton, GradientText } from './UI';
export function FAQAndClosingSection() {
  return <div className="bg-black text-white" data-id="element-49">
      {/* Objections / FAQ */}
      <Section className="border-t border-white/10" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-52">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-gray-400" data-id="element-53">
            Resolvemos tus dudas antes de que tomes la decisión.
          </p>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-54">
          <Accordion title="No tengo experiencia ni soy experto en nada. ¿Esto es para mí?" data-id="element-55">
            Absolutamente. El sistema te enseña cómo identificar habilidades,
            pasiones o problemas que ya has resuelto en tu vida y cómo
            empaquetarlos. Todos somos expertos en algo para alguien que está
            unos pasos más atrás.
          </Accordion>

          <Accordion title="No sé usar Inteligencia Artificial. ¿Será muy técnico?" data-id="element-56">
            Cero técnico. Te entregamos los prompts (instrucciones) exactos.
            Solo tienes que copiar, rellenar los espacios en blanco con tu idea,
            y pegar en ChatGPT o Claude. La IA hace el trabajo pesado, tú pones
            la dirección.
          </Accordion>

          <Accordion title="No tengo audiencia ni seguidores en redes sociales. ¿A quién le vendo?" data-id="element-57">
            El módulo de "Aceleración" y el bono de "200 Hooks Virales" están
            diseñados exactamente para esto. Te enseñamos a crear contenido
            magnético que atrae a tu cliente ideal desde cero, sin necesidad de
            ser influencer.
          </Accordion>

          <Accordion title="No tengo tiempo. Trabajo todo el día." data-id="element-58">
            Por eso usamos IA. Lo que antes tomaba meses de escritura y diseño,
            ahora toma días o incluso horas. Si puedes dedicarle 30-60 minutos
            al día, puedes tener tu activo digital listo en una semana.
          </Accordion>

          <Accordion title="¿Es un pago único o una suscripción?" data-id="element-59">
            Es un pago único. Obtienes acceso de por vida al libro, a los 3
            bonos y a todas las futuras actualizaciones sin cargos mensuales
            ocultos.
          </Accordion>
        </div>

        {/* WhatsApp help — for people who still have doubts */}
        <motion.div whileInView={{
        opacity: 1,
        y: 0
      }} initial={{
        opacity: 0,
        y: 20
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto mt-14 rounded-3xl border border-[#25D366]/30 bg-[#25D366]/10 p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-60">
          <div className="w-16 h-16 shrink-0 rounded-2xl bg-[#25D366]/20 flex items-center justify-center" data-id="element-61">
            <MessageCircle className="w-8 h-8 text-[#25D366]" data-id="element-62" />
          </div>
          <div className="flex-1" data-id="element-63">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-1" data-id="element-64">
              ¿Todavía tienes dudas antes de decidir?
            </h3>
            <p className="text-gray-400" data-id="element-65">
              Escríbenos por WhatsApp y una persona real te responderá todas tus
              preguntas al instante. Sin bots.
            </p>
          </div>
          <motion.a href="https://wa.me/1234567890?text=Hola,%20tengo%20una%20duda%20sobre%20Tu%20Primer%20Activo%20Digital" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05,
          y: -2
        }} whileTap={{
          scale: 0.96
        }} className="group shrink-0 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-black font-extrabold px-7 py-4 rounded-2xl shadow-[0_0_30px_-6px_rgba(37,211,102,0.7)] transition-colors" data-id="element-66">
            <MessageCircle className="w-5 h-5" data-id="element-67" />
            <span data-id="element-68">RESOLVER MIS DUDAS</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-69" />
          </motion.a>
        </motion.div>
      </Section>

      {/* The Crossroads (Emotional Close) */}
      <Section className="relative overflow-hidden py-32" data-id="element-70">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-blue-900/20 pointer-events-none" data-id="element-71" />

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-72">
          <h2 className="text-4xl md:text-6xl font-extrabold mb-8" data-id="element-73">
            La Decisión es Tuya
          </h2>

          <div className="text-xl md:text-2xl text-gray-300 space-y-6 mb-16 leading-relaxed font-medium" data-id="element-74">
            <p data-id="element-75">Dentro de un año, el tiempo habrá pasado de todas formas.</p>
            <p data-id="element-76">
              Puedes tener más cursos a medias en tu disco duro. Más videos
              guardados en TikTok. Más ideas en tu cabeza que nunca vieron la
              luz.
            </p>
            <p className="text-white font-bold text-2xl md:text-3xl my-12 p-8 bg-white/5 border border-white/10 rounded-3xl" data-id="element-77">
              O puedes mirar atrás y decir:
              <br data-id="element-78" />
              <br data-id="element-79" />
              <GradientText data-id="element-80">
                "Ese fue el día en que dejé de prepararme y finalmente construí
                mi primer activo."
              </GradientText>
            </p>
            <p data-id="element-81">
              No necesitas saberlo todo. Solo necesitas construir el primero.
            </p>
          </div>

          {/* Offer Recap */}
          <div className="max-w-md mx-auto bg-black/50 border border-white/10 rounded-3xl p-8 mb-12 text-left backdrop-blur-md" data-id="element-82">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-83">
              Resumen de tu pedido:
            </h4>
            <ul className="space-y-4 text-gray-300 font-medium" data-id="element-84">
              <li className="flex items-center gap-3" data-id="element-85">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-86" /> Tu
                Primer Activo Digital™
              </li>
              <li className="flex items-center gap-3" data-id="element-87">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-88" />{' '}
                Bono: 500 Prompts Premium
              </li>
              <li className="flex items-center gap-3" data-id="element-89">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-90" />{' '}
                Bono: 50 Nichos Rentables
              </li>
              <li className="flex items-center gap-3" data-id="element-91">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-92" />{' '}
                Bono: 200 Hooks Virales
              </li>
              <li className="flex items-center gap-3" data-id="element-93">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-94" />{' '}
                Garantía Blindada de 7 Días
              </li>
              <li className="flex items-center gap-3" data-id="element-95">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-96" />{' '}
                Acceso Inmediato
              </li>
            </ul>
            <div className="mt-8 pt-6 border-t border-white/10 text-center" data-id="element-97">
              <div className="text-sm text-gray-400 mb-1" data-id="element-98">
                Precio Especial Hoy:
              </div>
              <div className="text-4xl font-extrabold text-yellow-400" data-id="element-99">
                $17.99
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-100">
            <CTAButton text="CONSTRUIR MI FUTURO HOY" subtext="Acceso inmediato • Pago único" variant="primary" data-id="element-101" />
            <div className="flex items-center gap-4 text-sm text-gray-500 mt-2" data-id="element-102">
              <span className="flex items-center gap-1" data-id="element-103">
                <ShieldCheck className="w-4 h-4" data-id="element-104" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-105">
                <Clock className="w-4 h-4" data-id="element-106" /> Acceso de por vida
              </span>
            </div>
          </div>
        </div>
      </Section>

      {/* Footer */}
      <footer className="border-t border-white/10 py-8 text-center text-gray-600 text-sm" data-id="element-107">
        <div className="container mx-auto px-4" data-id="element-108">
          <p data-id="element-109">
            © {new Date().getFullYear()} Tu Primer Activo Digital™. Todos los
            derechos reservados.
          </p>
          <div className="flex justify-center gap-4 mt-4" data-id="element-110">
            <a href="#" className="hover:text-white transition-colors" data-id="element-111">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-112">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-113">
              Contacto
            </a>
          </div>
        </div>
      </footer>
    </div>;
}